export const UPDATE_NOTIFICATION_LIST = 'UPDATE_NOTIFICATION_LIST';
export const ADD_SUCCESS_NOTIFICATION = 'ADD_SUCCESS_NOTIFICATION';
export const ADD_ERROR_NOTIFICATION = 'ADD_ERROR_NOTIFICATION';
export const ADD_HINT_NOTIFICATION = 'ADD_HINT_NOTIFICATION';
export const ADD_WARNING_NOTIFICATION = 'ADD_WARNING_NOTIFICATION';
